import styled from 'styled-components';

export const Container = styled.div`
  background-color: #fff;
  padding: 5px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  font-weight: bold;

  span {
    font-size: 18px;
    color: #6200ea;
  }
`;

export const CreateButtonWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  padding: 15px;
`;

export const Section = styled.div`
  height: 580px;
  display: flex;
  flex-direction: column;
  position: relative;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  overflow-x: auto;
`;
